var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasImovel
    ? _c(
        "div",
        [
          _vm.hasEndereco
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isMA && !_vm.isAP
                            ? _c("app-display", {
                                class: _vm.compararImovelReurb
                                  .mudouEnderecoImovel.mudouTipoLogradouro
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Tipo logradouro:",
                                  content: _vm.exibirCampoComum(
                                    _vm.cadastroOriginal.imovel.endereco,
                                    "tipoLogradouro"
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouLoteamantoVila
                              ? "text"
                              : "",
                            attrs: {
                              label: "Endereço:",
                              content: _vm.exibirCampoComum(
                                _vm.cadastroOriginal.imovel.endereco,
                                "loteamentoVila"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouNumero
                              ? "text"
                              : "",
                            attrs: {
                              label: "Número:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "numero"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouComplemento
                              ? "text"
                              : "",
                            attrs: {
                              label: "Complemento:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "complemento"
                                ) || "-",
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouBairro
                              ? "text"
                              : "",
                            attrs: {
                              label: "Bairro:",
                              content: _vm.exibirCampoComum(
                                _vm.cadastroOriginal.imovel.endereco,
                                "bairro"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouArea
                              ? "text"
                              : "",
                            attrs: {
                              label: "Área do imóvel (m²):",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel,
                                  "area"
                                ) || "-",
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      !_vm.isAP
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb
                                  .mudouAreaConstruida
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: _vm.isMA
                                    ? "Perímetro do lote (m²):"
                                    : "Área construída:",
                                  content:
                                    _vm.exibirCampoComum(
                                      _vm.cadastroOriginal.imovel,
                                      "areaConstruida"
                                    ) || "-"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouQuadra
                              ? "text"
                              : "",
                            attrs: {
                              label: "Quadra:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "quadra"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouEnderecoImovel
                              .mudouLote
                              ? "text"
                              : "",
                            attrs: {
                              label: "Lote:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.endereco,
                                  "lote"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isAP
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb
                                  .mudouEnderecoImovel.mudouLote
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Há poço:",
                                  content: _vm.cadastroOriginal.imovel
                                    .possuiPoco
                                    ? "Sim"
                                    : "Não"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb
                                  .mudouEnderecoImovel.mudouLote
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Tipologia do poço:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.tipologiaPoco,
                                    "tipologiaPoco"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c("app-divider", {
            attrs: { label: "Características gerais do imóvel" }
          }),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouOcupacao
                          ? "text"
                          : "",
                        attrs: {
                          label: "Ocupação:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.ocupacao,
                            "ocupacao"
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouEstadoImovel
                          ? "text"
                          : "",
                        attrs: {
                          label: "Tipo:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.estadoImovel,
                            "estadoImovel"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouDominilidade
                          ? "text"
                          : "",
                        attrs: {
                          label: "Dominialidade:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.dominialidade,
                            "dominilidade"
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm.cadastroOriginal.imovel.regimeUsos &&
                  _vm.cadastroOriginal.imovel.regimeUsos.length > 0
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouRegimeUso
                              ? "text"
                              : "",
                            attrs: {
                              label: "Regime de uso:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.regimeUsos,
                                "regimeUsos"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cadastroOriginal.imovel.regimeUso
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouRegimeUso
                              ? "text"
                              : "",
                            attrs: {
                              label: "Regime de uso:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.regimeUso,
                                "regimeUso"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm.hasTerreno
            ? _c("app-divider", {
                attrs: { label: "Características do terreno" }
              })
            : _vm._e(),
          _vm.hasTerreno
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouLocalizacao
                              ? "text"
                              : "",
                            attrs: {
                              label: "Localização:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno.localizacao,
                                "localizacao"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm.cadastroOriginal.imovel.terreno.delimitacao
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouDelimitacao
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Delimitação:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .delimitacao,
                                    "delimitacao"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.cadastroOriginal.imovel.terreno.delimitacoes &&
                      _vm.cadastroOriginal.imovel.terreno.delimitacoes.length >
                        0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouDelimitacaos
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Delimitação:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .delimitacoes,
                                    "delimitacoes"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _vm.cadastroOriginal.imovel.terreno.situacao && !_vm.isMA
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouSituacao
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Situação:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .situacao,
                                    "situacao"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouCalcadaExterna
                              ? "text"
                              : "",
                            attrs: {
                              label: "Calçada externa:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno
                                  .calcadaExterna,
                                "calcadaExterna"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _vm.cadastroOriginal.imovel.terreno.topografia
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouTopografia
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Topografia:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.terreno
                                      .topografia,
                                    "topografia"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouQuintalAreaLivre
                              ? "text"
                              : "",
                            attrs: {
                              label: "Quintal área livre:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno
                                  .quintalAreaLivre,
                                "quintalAreaLivre"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasTerreno
            ? _c("app-divider", { attrs: { label: "Utilização do terreno" } })
            : _vm._e(),
          _vm.hasTerreno
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  !_vm.isMA
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouTerreno
                                  .mudouTotalUnidades
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Total de unidades:",
                                  content: _vm.exibirCampoComum(
                                    _vm.cadastroOriginal.imovel.terreno,
                                    "totalUnidades"
                                  )
                                }
                              })
                            ],
                            1
                          ),
                          _vm.cadastroOriginal.imovel.terreno.possuiPiscina
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display", {
                                    class: _vm.compararImovelReurb.mudouTerreno
                                      .mudouPossuiPiscina
                                      ? "text"
                                      : "",
                                    attrs: {
                                      label: "Existência de piscina:",
                                      content: _vm.exibirValor(
                                        _vm.cadastroOriginal.imovel.terreno
                                          .possuiPiscina,
                                        "possuiPiscina"
                                      ),
                                      marginBottom: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouTerreno
                              .mudouPossuiAnexo
                              ? "text"
                              : "",
                            attrs: {
                              label: "Existência de anexo:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.terreno.possuiAnexo,
                                "possuiAnexo"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasUnidade
            ? _c("app-divider", { attrs: { label: "Descrição da unidade" } })
            : _vm._e(),
          _vm.hasUnidade
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouTipoUnidade
                              ? "text"
                              : "",
                            attrs: {
                              label: "Tipo:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.unidade.tipoUnidade,
                                "tipoUnidade"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isMA
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouUnidade
                                  .mudouSituacao
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Situação:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.unidade
                                      .situacao,
                                    "situacao"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      !_vm.isMA
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouUnidade
                                  .mudouDisposicao
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Disposição:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.unidade
                                      .disposicao,
                                    "disposicao"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouImplantacao
                              ? "text"
                              : "",
                            attrs: {
                              label: "Implantação:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.unidade.implantacao,
                                "implantacao"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      !_vm.isMA
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouUnidade
                                  .mudouTipologia
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Tipologia:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.unidade
                                      .tipologia,
                                    "tipologia"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouQtdPavimento
                              ? "text"
                              : "",
                            attrs: {
                              label: "Quantidade de pavimento:",
                              content:
                                _vm.cadastroOriginal.imovel.unidade.qtdPavimento
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouPadraoConstrutivo
                              ? "text"
                              : "",
                            attrs: {
                              label: "Padrão construtivo:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.unidade
                                  .padraoConstrutivo,
                                "padraoConstrutivo"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouConservacao
                              ? "text"
                              : "",
                            attrs: {
                              label: "Conservação:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.unidade.conservacao,
                                "conservacao"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasUnidade
            ? _c("app-divider", { attrs: { label: "Uso da unidade" } })
            : _vm._e(),
          _vm.hasUnidade
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouUnidade
                              .mudouUsoSolos
                              ? "text"
                              : "",
                            attrs: {
                              label: "Uso do solo:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.unidade.usoSolos,
                                "usoSolos"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Características externas da construção" }
              })
            : _vm._e(),
          _vm.hasConstrucao
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouCoberturas
                              ? "text"
                              : "",
                            attrs: {
                              label: "Cobertura:",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.construcao
                                  .coberturas,
                                "coberturas"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display-multiple", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouEstruturas
                              ? "text"
                              : "",
                            attrs: {
                              label: "Estrutura (parede):",
                              content: _vm.exibirValores(
                                _vm.cadastroOriginal.imovel.construcao
                                  .estruturas,
                                "estruturas"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isMA
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouConstrucao
                                  .mudouParedes
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Paredes:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.construcao
                                      .paredes,
                                    "paredes"
                                  )
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouConstrucao
                                  .mudouRevestimentos
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Revestimento:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.construcao
                                      .revestimentos,
                                    "revestimentos"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Características internas da construção" }
              })
            : _vm._e(),
          _vm.hasConstrucao
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouFornecimentoEnergia
                              ? "text"
                              : "",
                            attrs: {
                              label: "Fornecimento de energia:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.construcao
                                  .fornecimentoEnergia,
                                "fornecimentoEnergia"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isMA
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouConstrucao
                                  .mudouInstalacaoEletrica
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Instalação elétrica:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.construcao
                                      .instalacaoEletrica,
                                    "instalacaoEletrica"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  !_vm.isMA
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _vm.cadastroOriginal.imovel.construcao
                            .utilizacaoSanitario
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display", {
                                    class: _vm.compararImovelReurb
                                      .mudouConstrucao.mudouUtilizacaoSanitario
                                      ? "text"
                                      : "",
                                    attrs: {
                                      label: "Utilização do sanitário:",
                                      content: _vm.exibirValor(
                                        _vm.cadastroOriginal.imovel.construcao
                                          .utilizacaoSanitario,
                                        "utilizacaoSanitario"
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.cadastroOriginal.imovel.construcao
                            .utilizacoesSanitarios &&
                          _vm.cadastroOriginal.imovel.construcao
                            .utilizacoesSanitarios.length > 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display-multiple", {
                                    class: _vm.compararImovelReurb
                                      .mudouConstrucao.mudouUtilizacaoSanitarios
                                      ? "text"
                                      : "",
                                    attrs: {
                                      label: "Utilização do sanitário:",
                                      content: _vm.exibirValores(
                                        _vm.cadastroOriginal.imovel.construcao
                                          .utilizacoesSanitarios,
                                        "utilizacoesSanitarios"
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.cadastroOriginal.imovel.construcao
                            .localizacaoSanitario
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display", {
                                    class: _vm.compararImovelReurb
                                      .mudouConstrucao.mudouLocalizacaoSanitario
                                      ? "text"
                                      : "",
                                    attrs: {
                                      label: "Localização do sanitário:",
                                      content: _vm.exibirValor(
                                        _vm.cadastroOriginal.imovel.construcao
                                          .localizacaoSanitario,
                                        "localizacaoSanitario"
                                      ),
                                      marginBottom: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.cadastroOriginal.imovel.construcao
                            .localizacoesSanitarios &&
                          _vm.cadastroOriginal.imovel.construcao
                            .localizacoesSanitarios.length > 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display-multiple", {
                                    class: _vm.compararImovelReurb
                                      .mudouConstrucao
                                      .mudouLocalizacaoSanitarios
                                      ? "text"
                                      : "",
                                    attrs: {
                                      label: "Localização do sanitário:",
                                      content: _vm.exibirValores(
                                        _vm.cadastroOriginal.imovel.construcao
                                          .localizacoesSanitarios,
                                        "localizacoesSanitarios"
                                      ),
                                      marginBottom: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isMA
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouConstrucao
                                  .mudouPisos
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Pisos:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.construcao
                                      .pisos,
                                    "pisos"
                                  )
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display-multiple", {
                                class: _vm.compararImovelReurb.mudouConstrucao
                                  .mudouForros
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Forro:",
                                  content: _vm.exibirValores(
                                    _vm.cadastroOriginal.imovel.construcao
                                      .forros,
                                    "forros"
                                  ),
                                  marginBottom: true
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouNumCompartimentos
                              ? "text"
                              : "",
                            attrs: {
                              label: "Número de compartimentos:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.construcao,
                                  "numCompartimentos"
                                ) || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouNumQuartos
                              ? "text"
                              : "",
                            attrs: {
                              label: "Número de quartos:",
                              content:
                                _vm.exibirCampoComum(
                                  _vm.cadastroOriginal.imovel.construcao,
                                  "numQuartos"
                                ) || "-",
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isMA
                    ? _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }),
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouConstrucao
                              .mudouNumSanitarios
                              ? "text"
                              : "",
                            attrs: {
                              label: "Número de sanitários:",
                              content: _vm.exibirCampoComum(
                                _vm.cadastroOriginal.imovel.construcao,
                                "numSanitarios"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.hasConstrucao
            ? _c("app-divider", {
                attrs: { label: "Saneamento básico e meio ambiente" }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouSistemaSanitario
                          ? "text"
                          : "",
                        attrs: {
                          label: "Sistema do sanitário:",
                          content: _vm.exibirValor(
                            _vm.cadastroOriginal.imovel.sistemaSanitario,
                            "sistemaSanitario"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display-multiple", {
                        class: _vm.compararImovelReurb.mudouDestinacaoLixos
                          ? "text"
                          : "",
                        attrs: {
                          label: "Destinação do lixo:",
                          content: _vm.exibirValores(
                            _vm.cadastroOriginal.imovel.destinacaoLixos,
                            "destinacaoLixos"
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display-multiple", {
                        class: _vm.compararImovelReurb.mudouAbastecimentoAgua
                          ? "text"
                          : "",
                        attrs: {
                          label: "Tipo de abastecimento de água:",
                          content: _vm.exibirValores(
                            _vm.cadastroOriginal.imovel.abastecimentosAgua,
                            "abastecimentosAgua"
                          ),
                          marginBottom: true
                        }
                      })
                    ],
                    1
                  ),
                  _vm.cadastroOriginal.imovel.arborizacao && !_vm.isMA
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouArborizacao
                              ? "text"
                              : "",
                            attrs: {
                              label: "Quantidade de unidades de arborização:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.arborizacao,
                                "arborizacao"
                              ),
                              marginBottom: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("app-divider", { attrs: { label: "Informações complementares" } }),
          _c(
            "div",
            { staticClass: "margin-top-10" },
            [
              !_vm.isMA
                ? _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb.mudouAquisicao
                              ? "text"
                              : "",
                            attrs: {
                              label: "Aquisição do imóvel:",
                              content: _vm.exibirValor(
                                _vm.cadastroOriginal.imovel.aquisicao,
                                "aquisicao"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm.cadastroOriginal.imovel.possuiAlvara
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                class: _vm.compararImovelReurb.mudouPossuiAlvara
                                  ? "text"
                                  : "",
                                attrs: {
                                  label: "Possui alvará:",
                                  content: _vm.exibirValor(
                                    _vm.cadastroOriginal.imovel.possuiAlvara,
                                    "possuiAlvara"
                                  )
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _vm.isAP
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class: _vm.compararImovelReurb
                              .mudouObservacoesGerais
                              ? "text"
                              : "",
                            attrs: {
                              label: "Parecer técnico",
                              content:
                                _vm.cadastroOriginal.imovel.parecerTecnico ||
                                "-"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class: _vm.compararImovelReurb.mudouObservacoesGerais
                          ? "text"
                          : "",
                        attrs: {
                          label: _vm.isAP
                            ? "Observações gerais:"
                            : "Informações necessárias (se houver):",
                          content:
                            _vm.cadastroOriginal.imovel.observacoesGerais || "-"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.isMA && _vm.hasDadosDeclaracaoPosseImovel
            ? _c("app-divider", {
                attrs: { label: "Declaração de posse do imóvel" }
              })
            : _vm._e(),
          _vm.isMA && _vm.hasDadosDeclaracaoPosseImovel
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-display", {
                            class: "text",
                            attrs: {
                              label:
                                "Você possui declaração de posse do imóvel?",
                              content: _vm.hasDeclaracaoPosse ? "Sim" : "Não"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.hasDeclaracaoPosse
                        ? _c(
                            "div",
                            [
                              _c("app-display", {
                                class: "text",
                                staticStyle: {
                                  "text-align": "center",
                                  "font-weight": "bold"
                                },
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_TITULO
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_1
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_2
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_POSSE_3
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: { content: this.tempoPosse }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isMA && _vm.hasDadosDeclaracaoResidencia
            ? _c("app-divider", {
                attrs: { label: "Declaração de residência" }
              })
            : _vm._e(),
          _vm.isMA && _vm.hasDadosDeclaracaoResidencia
            ? _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-display", {
                            class: "text",
                            attrs: {
                              label: "Você possui declaração de residência?",
                              content: _vm.cadastroOriginal.imovel
                                .possuiDeclaracaoResidencia
                                ? "Sim"
                                : "Não"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.cadastroOriginal.imovel.possuiDeclaracaoResidencia
                        ? _c(
                            "div",
                            [
                              _c("app-display", {
                                class: "text",
                                staticStyle: {
                                  "text-align": "center",
                                  "font-weight": "bold"
                                },
                                attrs: {
                                  content: this.messages
                                    .TITULO_DECLARACAO_RESIDENCIA
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: { content: this.endereco }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                staticStyle: { "margin-left": "60px" },
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA_LEI
                                }
                              }),
                              _c("app-display", {
                                class: "text",
                                attrs: {
                                  content: this.messages
                                    .TEXTO_DECLARACAO_RESIDENCIA_ASSINATURA
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46a639bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a639bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesImovelReurb.vue
// module id = null
// module chunks = 